/* tslint:disable */

declare var Object: any;
export interface ProfessionAnnualWagesIndexInterface {
  "profession": string;
  "wages": any;
  "year": number;
  "id"?: any;
}

export class ProfessionAnnualWagesIndex implements ProfessionAnnualWagesIndexInterface {
  "profession": string;
  "wages": any;
  "year": number;
  "id": any;
  constructor(data?: ProfessionAnnualWagesIndexInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProfessionAnnualWagesIndex`.
   */
  public static getModelName() {
    return "ProfessionAnnualWagesIndex";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProfessionAnnualWagesIndex for dynamic purposes.
  **/
  public static factory(data: ProfessionAnnualWagesIndexInterface): ProfessionAnnualWagesIndex{
    return new ProfessionAnnualWagesIndex(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProfessionAnnualWagesIndex',
      plural: 'ProfessionAnnualWagesIndexes',
      properties: {
        "profession": {
          name: 'profession',
          type: 'string'
        },
        "wages": {
          name: 'wages',
          type: 'any'
        },
        "year": {
          name: 'year',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ProfessionAnnualWagesIndex.ts